export const VOUCHER_EMAIL_LOGIN_COMPLETE_QUERY = 'voucherEmailLogin'
export const VOUCHER_EMAIL_LOGIN_COMPLETE_VALUE = '1'
export const VOUCHER_EMAIL_SESSION_TIMEOUT_MS = 10 * 60 * 1000
export const VOUCHER_EMAIL_SESSION_EXPIRED_MESSAGE =
  '바우처 확인 시간이 만료되었습니다.<br>다시 확인해주세요.'

export const isVoucherEmailRoute = (route = {}) =>
  Boolean(
    route.name === 'voucherEmail' ||
      route.meta?.voucherEmail ||
      route.matched?.some((matched) => matched.meta?.voucherEmail)
  )

export const hasVoucherEmailLoginCompleted = (route = {}) =>
  String(route.query?.[VOUCHER_EMAIL_LOGIN_COMPLETE_QUERY] || '') ===
  VOUCHER_EMAIL_LOGIN_COMPLETE_VALUE

export const shouldForceVoucherEmailLogin = (route = {}) =>
  isVoucherEmailRoute(route) && !hasVoucherEmailLoginCompleted(route)

export const appendVoucherEmailLoginCompleteQuery = (fullPath = '') => {
  const [pathWithQuery, hash = ''] = fullPath.split('#')

  if (new RegExp(`[?&]${VOUCHER_EMAIL_LOGIN_COMPLETE_QUERY}=`).test(pathWithQuery)) {
    return fullPath
  }

  const separator = pathWithQuery.includes('?') ? '&' : '?'
  const hashSuffix = hash ? `#${hash}` : ''

  return `${pathWithQuery}${separator}${VOUCHER_EMAIL_LOGIN_COMPLETE_QUERY}=${VOUCHER_EMAIL_LOGIN_COMPLETE_VALUE}${hashSuffix}`
}

export const createVoucherEmailLoginUrl = ({
  fullPath = '',
  redirectOrigin,
  accountHost,
  siteId,
}) => {
  const redirectUri = `${redirectOrigin}${appendVoucherEmailLoginCompleteQuery(fullPath)}`

  return `${accountHost}?siteId=${siteId}&redirectUri=${encodeURIComponent(redirectUri)}`
}

/**
 * 이메일 바우처는 기존 로그인 상태여도 주문자 본인 확인을 위해 다시 로그인해야 한다.
 * 닷컴 로그인 세션이 남아 있으면 로그인 페이지를 건너뛸 수 있어서, 계정 로그아웃을 먼저 거쳐 로그인 URL로 이동시킨다.
 */
export const createVoucherEmailLoginCheckUrl = ({
  fullPath = '',
  redirectOrigin,
  accountHost,
  siteId,
}) => {
  const loginUrl = createVoucherEmailLoginUrl({ fullPath, redirectOrigin, accountHost, siteId })

  return `${accountHost}/logout?redirectUri=${encodeURIComponent(loginUrl)}`
}

export const createVoucherEmailFetchUrl = (voucherId) =>
  `/order/v1/order/${voucherId}/voucher/email`
